export default __webpack_public_path__ + "static/media/withdraw.0d4a2957.svg";